import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ScullyRoutesService } from '@scullyio/ng-lib';
import { combineLatest } from 'rxjs';
import { map, pluck } from 'rxjs/operators';
import { SEOService } from '../../services/seo.service';

@Component({
  selector: 'app-approfondimenti-post',
  templateUrl: './approfondimenti-post.component.html',
  styleUrls: ['./approfondimenti-post.component.scss']
})
export class ApprofondimentiPostComponent implements OnInit {

  pageTitle = "Leone Lifestyle";
  desc = "La nuova era della nutrizione e del benessere"
  shareImg = "approfondimenti/";

  constructor(
    private activatedRoute: ActivatedRoute,
    private scully: ScullyRoutesService,
    private seo: SEOService
  ) {}

  $blogPostMetadata = combineLatest([
    this.activatedRoute.params.pipe(pluck('approfondimentiId')),
    this.scully.available$
  ]).pipe(
    map(([approfondimentiId, routes]) =>
      routes.find(route => route.route === `/approfondimenti/${approfondimentiId}`)
    )
  );

  blog$ = this.scully.getCurrent();

  ngOnInit(): void {
    this.blog$.subscribe((b) => {
      this.seo.updatePageTags(b.pageTitle + " | " + this.pageTitle, this.desc, this.shareImg + b.shareImg);
    });
  }
}
